import { createContext } from "react";
import { QuoteData, BoardMemberData, ExecutiveData } from "~types/types";

export type QuoteContextType = QuoteData & {
  searchClientURL: string;
  pageType: string;
  boardMembers?: BoardMemberData[];
  executives?: ExecutiveData[];
  marketStatus: string;
  ultimateParentTicker?: string;
};

export const QuoteContext = createContext<QuoteContextType | null>(null);
